module.exports = __webpack_public_path__ + "img/offer-pc-out.caf3b14f.svg";